/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Box, Button, Divider, Tooltip, Typography } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import ApartmentIcon from "@mui/icons-material/Apartment";
import { Link, useNavigate } from "react-router-dom";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { ROUTE_PATH } from "../../constants/route";
import { toTwoDecimalPlaces } from "../../utils/commonFuntions";
import StyledPaymentSuccess from "../Checkout/StyledPaymentSuccess";

const KeepItemsPaymentSuccess = () => {
  const navigate = useNavigate();
  
  const getAllData = sessionStorage.getItem("KeepOrderData") || null;

  const keepProductPaymentDetails = JSON.parse(getAllData);  

  return (
    <StyledPaymentSuccess>
      <Box className='payment-success-wrap'>
        <Box className='payment-success-box'>
          <Box className='payment-success-icon-wrap'>
            <DoneIcon sx={{ fontSize: "33px", color: "white" }} />
          </Box>
        </Box>
        <Box className='payment-success-text-wrap'>
          <Typography className='payment-success-text-header'>
            Order Confirmed!
          </Typography>
          <Typography className='payment-success-text-body'>
          Your order is now complete, and your trip is all set! You can view this booking in your Past Trip Closet.
          </Typography>
        </Box>
        <Box className='trip-deatails'>
          <Typography className='trip-title'>Trip details</Typography>
          <Box className='info-container-2'>
            <Box className='info-container'>
              <ApartmentIcon className='icon-person-1' sx={{ color: "#A78D78" }} />
              <Typography className='bold-text-1'>{keepProductPaymentDetails?.tripDetails?.hotel_name}</Typography>
            </Box>
            <Typography className='location-text'>{keepProductPaymentDetails?.tripDetails?.city_name}</Typography>
            <Box>
              <Typography className='arrival-text'>
                <Typography className='arrival-text-1'>Arrival date</Typography>
                  <Typography className='arrival-bold-span'>{keepProductPaymentDetails?.tripDetails?.arrival_date}</Typography>
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box className='payment-summary-wrap'>
          <Box className='payment-summary'>
            <Typography className='payment-summary-header'>
              Amount Summary
            </Typography>
            <Box className="amount-container">
              <Typography className="amount-text">
                Subtotal
                <Tooltip
                  title='Payable amount for kept items after trial.'
                  arrow
                  placement='right'
                >
                  <InfoOutlinedIcon fontSize='small' className='infoIcon' />
                </Tooltip>
              </Typography>
              <Typography className="amount">{keepProductPaymentDetails ? `$${keepProductPaymentDetails?.keptItemsTotal }` : "--"}</Typography>
            </Box>
            <Box className="amount-container-dashed">
              <Typography className="amount-text">Reservation fee</Typography>
              <Typography className="amount">{keepProductPaymentDetails? `$${toTwoDecimalPlaces(keepProductPaymentDetails?.service_fee || keepProductPaymentDetails?.bagItems?.[0]?.service_fees)}` : "--"}</Typography>
            </Box>
            {keepProductPaymentDetails?.tripDetails?.tax_payment_component?.length > 0
                  ? keepProductPaymentDetails?.tripDetails?.tax_payment_component.map((element) =>
                     {
                      return (
                        <Box className="amount-container">
                          <Typography className="amount-text">
                            {element?.name}
                          </Typography>
                          <Typography className="amount">{`$${toTwoDecimalPlaces(element?.applied_value)}`}</Typography>
                        </Box>
                      );
                    })
                  : null}
            <Divider />
            <Box className="amount-container">
              <Typography className="total-amount-text">Total Amount Paid</Typography>
              <Typography className="total-amount">{keepProductPaymentDetails ? `$${toTwoDecimalPlaces(parseInt(keepProductPaymentDetails?.keptItemsTotal) + parseInt(keepProductPaymentDetails?.tripDetails?.tax_payment_component?.reduce((sum, element) => sum + parseFloat(element?.applied_value), 0)))}` : "--"}</Typography>
            </Box>
          </Box>
        </Box>
        <Box className='button-wrap'>
          <Button className='continue-shopping-btn' onClick={() => navigate(ROUTE_PATH.HOME)}>Continue shopping</Button>
          <Link to={`${ROUTE_PATH.CLOSET}?tab=Planned`} className="view-planned-trip-btn">View planned trip</Link>
        </Box>
      </Box>
    </StyledPaymentSuccess>
  );
};

export default KeepItemsPaymentSuccess;
